import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthenticationInfoService } from './authentication-info.service';
import { Observable, filter, map } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  unauthorizedUrl: string = '/unauthorized';

  constructor(
    private router: Router,
    private userService: AuthenticationInfoService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let requiredMembershipGroup = route.data.requiredMembership;

    return this.userService.userProfileLoaded$.pipe(
      filter(userProfile => !_.isNil(userProfile)),
      map(userProfile => {

        if (_.isNil(requiredMembershipGroup)) {
          return true;
        }

        if (!userProfile.hasAnyGrantAccess) {
          this.router.navigate([this.unauthorizedUrl]);
          return false;
        }

        let result : boolean = false;
        requiredMembershipGroup.forEach(element => {
          result = result || userProfile.hasGrant(element);
        });

        if (result === false) {
          this.router.navigate([this.unauthorizedUrl]);
          return false;
        }
        return true;
      }));

  }
}
